
import React, { useState, useEffect } from 'react';
import { IconInfoError } from '../Icons';

interface CheckboxProps {
    id?: string;
    label?: string;
    selected?: boolean;
    selectable?: boolean;
    required?: boolean;
    invalid?: boolean;
    onSelect?: (selected: boolean, id?: string) => void;
    ['data-pw']?: string;
}

export const Checkbox: React.FC<CheckboxProps> = props => {
    const [selected, setSelected] = useState<boolean>(!!props.selected);

    const onSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.selectable === false) return;

        e.stopPropagation();
        setSelected(!selected);
        props.onSelect?.(!selected, props.id);
    };

    useEffect(() => {
        setSelected(!!props.selected);
    }, [props.selected]);

    return (
        <div>
            <div
                className={
                    'styled-checkbox' + (props.invalid ? ' invalid' : '')
                }>
                <input
                    id={props.id}
                    data-pw={props['data-pw'] ?? props.id}
                    type="checkbox"
                    checked={selected}
                    onChange={onSelect}
                    required={props.required}
                />
                <p>{props.label}</p>
            </div>
            {props.invalid && (
                <div className="inline-flex gap-2 p-1 items-center">
                    <IconInfoError />
                    <h6>{'Eingabe erforderlich'}</h6>
                </div>
            )}
        </div>
    );
};
